(ns frontend.ui.page.nnev.header.editor
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [ui.components.sortable-list.view :as sortable-list]
   [reagent.core :as r]
   [ui.components.select.select :as select]
   [ui.components.button.view :as button]))

(def layout-defs
  [[:f-4 [100]]
   [:f-2-2 [50 50]]
   [:f-1-1-1-1 [25 25 25 25]]
   [:f-1-1-2 [25 25 50]]
   [:f-2-1-1 [50 25 25]]
   [:f-1-2-1 [25 50 25]]
   [:f-3-1 [75 25]]
   [:f-1-3 [25 75]]])

(def layout-options
  [[:f-4 "4"]
   [:f-1-1-1-1 "1+1+1+1"]
   [:f-2-2 "2+2"]
   [:f-1-1-2 "1+1+2"]
   [:f-2-1-1 "2+1+1"]
   [:f-1-2-1 "1+2+1"]
   [:f-3-1 "3+1"]
   [:f-1-3 "1+3"]])

(def layout-labels
  (->> layout-options
       (into {})))

(def layout-options-opts
  (->> layout-options
       (map (fn [[k label]]
              {:value k
               :label label}))))

(def layout-widths
  (->> layout-defs
       (into {})))

;;(declare frontend.view.entity-viewers.entity-editor/resolve-template)

(defn field-selector
  [{:keys [schema entity options field select-field!]}]
  (let [options (->> schema
                     (map (fn [[k {:keys [label] :as fs}]]
                            {:value k
                             :label (or label (loc/field-name k fs))})))]
    [:div
     {:class ""}
     [select/view
      {:value       {:value field
                     :label (->> options
                                 (cu/filter-by :value field)
                                 (first)
                                 :label)}
       :options     options
       :placeholder (loc/tr :select-field)
       :on-change   select-field!}]]))

;;TIMO seems it's outdated?

;; (def layout-images
;;   [[:f-4 "/img/layouts/layout_4.svg"]
;;    [:f-2-2 "/img/layouts/layout_2+2.svg"]
;;    [:f-2-1-1 "/img/layouts/layout_2+1+1.svg"]
;;    [:f-1-2-1 "/img/layouts/layout_1+2+1.svg"]
;;    [:f-1-3 "/img/layouts/layout_1+3.svg"]
;;    [:f-3-1 "/img/layouts/layout_3+1.svg"]
;;    [:f-1-1-2 "/img/layouts/layout_1+1+2.svg"]
;;    [:f-1-1-1-1 "/img/layouts/layout_1+1+1+1.svg"]])

;; (defn layout-image-view
;;   [layout-key image-url selected? select-layout!]
;;   [:div.pr-1
;;    [:span
;;     {:class    (<class style/field-layout-image selected? image-url)
;;      :on-click (partial select-layout! layout-key)}]])

;; (defn layout-selector
;;   [{:keys [field-layout select-layout!]}]
;;   [:div
;;    [:span.text-size--sm.text-color--light-grey (loc/tr :select-new-layout)]
;;    [:div.d-flex.mt-1
;;     (for [[layout image] (take 4 layout-images)
;;           :let [selected? (= field-layout layout)]]
;;       ^{:key (str layout)}
;;       [layout-image-view layout image selected? select-layout!])]
;;    [:div.d-flex
;;     (for [[layout image] (drop 4 layout-images)
;;           :let [selected? (= field-layout layout)]]
;;       ^{:key (str layout)}
;;       [layout-image-view layout image selected? select-layout!])]])

;;TODO select-component or similar with layout images above - for now using
;;     just text:
(defn layout-selector-input
  [{:keys [field-layout select-layout!]}]
  [select/view
   {:options     layout-options-opts
    :value       (->> layout-options-opts
                      (cu/filter-by :value field-layout)
                      (first))
    :placeholder (loc/tr :select)
    :on-change   select-layout!}])

(defn row
  [{:keys [item index schema entity select-layout! select-field! remove!]}]
  (let [field-row-def item
        {:keys [field-layout fields]} field-row-def]
    [:div
     {:class "my-2 flex items-center justify-center gap-3"}
     [:div
      {:class "flex-1"}
      [:div
       {:class "grid grid-cols-3 gap-4"}
       (->> (get layout-widths field-layout)
            (map-indexed (fn [i width]
                           (let [config (get fields i)]
                             ^{:key (str "field-" i "-" (:field config))}
                             [:div
                              [field-selector
                               (assoc config
                                      :schema schema
                                      :entity entity
                                      :select-field! (r/partial select-field! index i))]])))
            (doall))]]
     [:div
      {:class "w-[110px]"}
      [:div
       [layout-selector-input
        {:field-layout   field-layout
         :select-layout! (partial select-layout! index)}]]]
     (when (fn? remove!)
       [:div
        {:class "*:px-0"}
        [button/square-secondary-open
         {:on-click #(remove! index)}
         [:i.fas.fa-times-circle]]])]))

(defn field-rows
  [{:keys [field-defs entity schema select-layout! select-field! remove-row! reorder! sort-mode?]}]
  (let [row-params {:schema         schema
                    :entity         entity
                    :select-layout! select-layout!
                    :select-field!  select-field!
                    :remove!        remove-row!}]
    (if sort-mode?
      [:div
       [sortable-list/view
        {:items (->> field-defs
                     (map-indexed
                      (fn [index item]
                        (assoc item :index index)))
                     vec)
         :get-key :index
         :on-reorder (fn [{:keys [source-index destination-index]}]
                       (reorder! source-index destination-index))
         :render-item (fn [{:keys [item index]}]
                        [:div
                         {:class "flex items-center gap-2 p-1 bg-base-light"}
                         [:div
                          {:class "cursor-grab"}
                          [sortable-list/drag-handle-icon]]
                         [row (assoc row-params
                                     :item item
                                     :index index)]])}]]
      [:div
       (->> field-defs
            (map-indexed (fn [index item]
                           ^{:key (str "-" index)}
                           [row (assoc row-params
                                       :item item
                                       :index index)]))
            (doall))])))
